import Button from "@components/Button";
import CircularLoader from "@components/CircularLoader";
import ScalableWrapper from "@components/ScalableWrapper";
import View from "@components/View";
import { useUrlMapper } from "@src/contexts/URLMapperContext";
import { useManager } from "@src/contexts/WarsContext";
import { images } from "@utils/media";
import { useState } from "react";

const TrialBaseGameTicketPopup = (props: {
  rewardId?: string;
  closePopup: () => void;
}) => {
  const { rewardId, closePopup } = props;

  const manager = useManager();

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const claim = async () => {
    if (!rewardId) return;
    setIsLoading(true);
    await manager.claimInGameReward(rewardId);
    setIsLoading(false);
    closePopup();
  };

  return (
    <View className="w-screen h-dvh absolute top-0 left-0 z-[999999] font-[Slackey]">
      <View
        enableEventCapturing
        className="w-full h-full absolute top-0 left-0 bg-black/60"
      />
      <ScalableWrapper maintainAspectRatioBy="height">
        <View className="w-full h-full flex items-center justify-center">
          <View
            enableEventCapturing
            className="relative bg-[#F72EC5] w-[40rem] p-1.5 rounded-xl flex flex-col items-center"
          >
            <h1
              className="text-white mt-0.5 mb-2"
              style={{ textShadow: "0px 3.1px 0px rgba(0, 0, 0, 1)" }}
            >
              7 Days Ticket
            </h1>
            <View className="w-full h-80 bg-gradient-to-t from-[#3355FF] to-[#5B7CFF] rounded-b-xl overflow-hidden">
              <View
                className="w-full h-full bg-cover bg-no-repeat flex flex-col items-center justify-center gap-4"
                style={{ backgroundImage: `url(${images.TilesBackground})` }}
              >
                <View
                  className="w-full h-52 flex flex-col items-center justify-center text-center text-white leading-none px-12"
                  style={{ textShadow: "0px 3.1px 0px rgba(0, 0, 0, 1)" }}
                >
                  <>
                    <h1>Welcome to The Last show!</h1>
                    <h1>
                      You are now part of an exclusive early release of a new
                      Discord game.
                    </h1>
                  </>
                </View>
                <View className="flex justify-center">
                  <View
                    enableEventCapturing
                    style={{ backgroundImage: `url(${images.PopupButton})` }}
                    className="w-96 h-14 bg-contain bg-no-repeat"
                  >
                    <Button
                      className="flex items-center justify-center bg-transparent border-none outline-none w-96 h-14 font-[Slackey] text-2xl"
                      onClick={claim}
                      disabled={isLoading}
                    >
                      {isLoading ? (
                        <>
                          <CircularLoader className="mr-3 -ml-1 size-6 animate-spin text-black" />
                          <span>Claiming</span>
                        </>
                      ) : (
                        <span>CLAIM TICKET</span>
                      )}
                    </Button>
                  </View>
                </View>
              </View>
            </View>
          </View>
        </View>
      </ScalableWrapper>
    </View>
  );
};

export default TrialBaseGameTicketPopup;
